export default "__VITE_ASSET__CAW1gNdB__"